// extracted by mini-css-extract-plugin
export var borderRadius = "_an-4";
export var large = "_an-3";
export var logoContainer = "_an-0";
export var nameLogo = "_an-2";
export var small = "_an-1";